<div class="modal-header border-bottom-0">
  <h4 class="modal-title body-bold-16 slate-600">
    {{'general.select_services' | translate}}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <app-close-icon></app-close-icon>
  </button>
</div>
<div>
  <mat-selection-list multiple="true" #services>
    <mat-list-option *ngFor="let service of allServices" [disableRipple]="true" [selected]="isSelected(service)"
      [value]="service">
      {{service?.name}}
    </mat-list-option>
  </mat-selection-list>
</div>
<div class="modal-footer border-top-0">
  <div class="flex">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Close click')">
      {{'general.close' | translate}}
    </button>
    <button type="button" class="btn btn-primary mx-16" (click)="save()">
      {{'general.save' | translate}}
    </button>
  </div>